<script lang="ts">
  import { I18n } from "i18n-js"
  import i18n_translations from "../../../../javascript/locales.json"

  let {
    locale,
    messages = [],
  } = $props()

  const i18n = new I18n(i18n_translations)
  i18n.locale = locale
  i18n.defaultLocale = "en"
  i18n.enableFallback = true
</script>

{#if messages.length}
  <div id="flash">
    <div class="error" role="alert">
      <p class="mb-2">
        <strong>{i18n.t('form_errors.title')}</strong>
      </p>
      <ul class="mb-0">
        {#each messages as message}
          <li>{message}</li>
        {/each}
      </ul>
    </div>
  </div>
{/if}
